function fieldOf(bar, field) {
  if (!bar) return null;
  const aliases = {
    close: ['close', 'Close'],
    open: ['open', 'Open'],
    high: ['high', 'High'],
    low: ['low', 'Low'],
  };
  for (const key of aliases[field] || [field]) {
    const n = typeof bar[key] === 'number' ? bar[key] : parseFloat(bar[key]);
    if (Number.isFinite(n)) return n;
  }
  return null;
}

export function sma(values, period) {
  const n = Math.max(1, Math.floor(Number(period) || 1));
  const out = new Array(values.length).fill(null);
  let sum = 0;
  for (let i = 0; i < values.length; i++) {
    const v = values[i];
    if (!Number.isFinite(v)) {
      out[i] = i > 0 ? out[i - 1] : null;
      continue;
    }
    sum += v;
    if (i >= n && Number.isFinite(values[i - n])) sum -= values[i - n];
    if (i >= n - 1) out[i] = sum / n;
  }
  return out;
}

export function smaFromBars(bars, period, field = 'close') {
  return sma((bars || []).map((b) => fieldOf(b, field)), period);
}
